export default __webpack_public_path__ + "static/media/poi_fireStation_multi.b891ad2c.svg";